/*
 * Module for handling the modal view of a single learner transcript.
 */

define([
  "marionette",
  "messaging/messenger",
  "modules/learner/learnerTranscriptModal/learnerTranscriptModalView",
  "modules/learner/learnerTranscriptModal/conversationTranscript/conversationTranscriptModule",
  "modules/learner/learnerTranscriptModal/conversationTranscriptDetails/conversationTranscriptDetailsModule",
  "modules/shared/selectableList/selectableListModule",
], function (
  Marionette,
  Messenger,
  LearnerTranscriptModalView,
  ConversationTranscriptModule,
  ConversationTranscriptDetailsModule,
  SelectableListModule,
) {
  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "learnerTranscriptModal";
      this.region = options.region;
      this.matchType = options.matchType;
      this.disableLearnerFeatures = options.disableLearnerFeatures;
      this._setUpVents();
    },
    show: function (transcript) {
      transcript.authoringStatuses = Messenger.reqres.request("kb:mart:statuses");
      this.layout = new LearnerTranscriptModalView.learnerTranscriptModalLayout({
        model: transcript,
      });
      this.conversationTranscript = this.addSubModule(
        new ConversationTranscriptModule({ region: this.layout.conversation }),
      );
      this.conversationTranscriptDetails = this.addSubModule(
        new ConversationTranscriptDetailsModule({
          region: this.layout.conversationDetails,
          matchType: this.matchType,
        }),
      );
      if (transcript.isCluster) {
        this.childList = this.addSubModule(
          new SelectableListModule({ region: this.layout.clusterChildren }),
        );
      }
      //Change the status of the transcript
      this.layout.on(
        "change:status",
        function (statusId) {
          //save the updated transcript
          transcript.updateStatus(statusId);
        },
        this,
      );

      //Delete the transcript
      this.layout.on(
        "delete",
        function () {
          //delete after user confirmation
          //use different delete message for clusters
          let deleteMsg;
          if (transcript.isCluster) {
            deleteMsg = "learner.transcript.dialog.clusterDelete";
          } else {
            deleteMsg = "learner.transcript.dialog.delete";
          }
          Messenger.yesNoDialog(
            deleteMsg,
            {
              yes: function () {
                Messenger.vent.trigger("track:interaction", {
                  action: "Delete Learner Transcript",
                  id: transcript.id,
                  idType: "Learner Transcript",
                  object: "Learner Transcript",
                });
                transcript.deleteModel();
                Messenger.vent.trigger("delete:clustering:jobs");
                //trigger closing the modal
                Messenger.vent.trigger("close:modal");
              },
            },
            this,
          );
        },
        this,
      );

      //A transcript was selected to be added to a topic.  So go to the topics page, show the minilearner and set the highlighted transcript
      this.layout.on(
        "add:to:topic",
        function () {
          // Make sure this modal is closed before showing any other UI
          Messenger.vent.trigger("close:modal", () => {
            Messenger.vent.trigger("show:topics");
            Messenger.vent.trigger("show:mini:learner", true); //expand learner
            Messenger.vent.trigger("set:highlighted:transcript", this.selectedTranscript);
          });
        },
        this,
      );

      //create a new topic using the transcript
      this.layout.on(
        "create:new:topic",
        function () {
          //now that the topics page is at least initialized, trigger this event on the topics page to add a new topic
          const configSettings = Messenger.reqres.request("learner:config:settings");
          // Make sure this modal is closed before showing any other UI
          Messenger.vent.trigger("close:modal", () => {
            Messenger.vent.trigger(
              "add:learner:topic",
              this.selectedTranscript,
              configSettings.localeId,
            );
          });
        },
        this,
      );

      this.layout.on(
        "show",
        function () {
          this._setHighlightedTranscript(transcript);
          this._showSubViews(transcript);
        },
        this,
      );
      this.showRegion(this.layout);
      if (this.disableLearnerFeatures) {
        Messenger.vent.trigger("disable:learner:features");
      }
    },
    _setHighlightedTranscript: function (transcript) {
      //show the selected transcript's utterance in the "highlighted" area
      this.layout.setHighlightedTranscript(
        transcript.get("userUtterance"),
        transcript.get("translatedUtterance"),
      );
      //keep track of which utterance is selected.  Use this transcript when adding to a topic.
      this.selectedTranscript = transcript;
    },
    _showSubViews: function (transcript) {
      var transcriptDetails;
      if (transcript.isCluster) {
        transcriptDetails = transcript
          .getChildren()
          .findWhere({ utteranceId: transcript.get("utteranceId") }); //use the representative transcript
        //pick the model that will be selected in the selectable list at render time
        this.childList.selectedModel = transcriptDetails;
        this.childList.show(transcript.getChildren());
      } else {
        transcriptDetails = transcript;
      }
      this.conversationTranscript.show(
        transcriptDetails.getConversationTranscript(),
        transcriptDetails.get("turn"),
      );
      this.conversationTranscriptDetails.show(transcriptDetails);
    },
    _setUpVents: function () {
      //a question in the cluster is selected from the list.  Show the details and conv. transcript.  Change the highlighted transcript to this one.
      Messenger.vent.on(
        "list:item:selected",
        function (transcript) {
          this.conversationTranscript.show(
            transcript.getConversationTranscript(),
            transcript.get("turn"),
          );
          this.conversationTranscriptDetails.show(transcript);
          this._setHighlightedTranscript(transcript);
        },
        this,
      );
      Messenger.vent.on(
        "disable:learner:features",
        function () {
          this.layout.disableLearnerFeatures(this.disableLearnerFeatures);
        },
        this,
      );
    },
  });
});
